const FREE_SHIPPING_THRESHOLD = 5000; // in Cent, z.B. 5000 = 50€
const UPSELL_COLLECTION = 'all'; // Handle deiner Upsell-Collection (Bestseller)

const CartDrawer = {
  drawer: null,
  overlay: null,

  init() {
    this.drawer = document.getElementById('cart-drawer');
    this.overlay = document.getElementById('cd-overlay');

    document.getElementById('cd-close')?.addEventListener('click', () => this.close());
    this.overlay?.addEventListener('click', () => this.close());
    document.getElementById('cd-discount-toggle')?.addEventListener('click', () => {
      document.getElementById('cd-discount-body')?.classList.toggle('is-open');
    });
    document.getElementById('cd-discount-apply')?.addEventListener('click', () => this.applyDiscount());
    document.getElementById('cd-upsell-next')?.addEventListener('click', () => {
      document.getElementById('cd-upsell-track')?.scrollBy({ left: 240, behavior: 'smooth' });
    });
    document.getElementById('cd-upsell-prev')?.addEventListener('click', () => {
      document.getElementById('cd-upsell-track')?.scrollBy({ left: -240, behavior: 'smooth' });
    });

    // Trigger von ATC Buttons
    document.addEventListener('cart:refresh', () => this.fetchAndRender());

    // Cart Icon Click
    document.querySelectorAll('[data-cart-trigger]').forEach(el => {
      el.addEventListener('click', (e) => { e.preventDefault(); this.open(); });
    });
  },

  open() {
    this.fetchAndRender();
    this.renderUpsell();
    this.drawer?.classList.add('is-open');
    this.overlay?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  },

  close() {
    this.drawer?.classList.remove('is-open');
    this.overlay?.classList.remove('is-open');
    document.body.style.overflow = '';
  },

  async fetchAndRender() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      this.render(cart);
    } catch (e) {
      console.error('Cart fetch failed', e);
    }
  },

  async renderUpsell() {
    const track = document.getElementById('cd-upsell-track');
    const upsellWrap = document.getElementById('cd-upsell');
    if (!track) return;
    try {
      const res = await fetch(`/collections/${UPSELL_COLLECTION}/products.json?limit=10`);
      const data = await res.json();
      if (!data.products || data.products.length === 0) {
        if (upsellWrap) upsellWrap.style.display = 'none';
        return;
      }
      if (upsellWrap) upsellWrap.style.display = 'block';
      track.innerHTML = data.products.map(p => {
        const v = p.variants[0];
        const price = parseFloat(v.price).toFixed(2).replace('.', ',');
        const compare = v.compare_at_price && parseFloat(v.compare_at_price) > parseFloat(v.price)
          ? parseFloat(v.compare_at_price).toFixed(2).replace('.', ',') : null;
        const img = p.images[0] ? p.images[0].src : '';
        return `
          <div class="cd__upsell-item">
            <img class="cd__upsell-img" src="${img}" alt="${p.title}">
            <div class="cd__upsell-body">
              <span class="cd__upsell-name">${p.title}</span>
              <div class="cd__upsell-prices">
                <span class="cd__upsell-price">${price} €</span>
                ${compare ? `<span class="cd__upsell-compare">${compare} €</span>` : ''}
              </div>
              <button class="cd__upsell-atc" onclick="CartDrawer.addUpsell(${v.id})">+ Hinzufügen</button>
            </div>
          </div>
        `;
      }).join('');
    } catch (e) {
      console.error('Upsell fetch failed', e);
      if (upsellWrap) upsellWrap.style.display = 'none';
    }
  },

  async addUpsell(variantId) {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });
    this.fetchAndRender();
  },

  render(cart) {
    // Count
    document.getElementById('cd-count').textContent = cart.item_count;

    // Shipping bar
    const remaining = FREE_SHIPPING_THRESHOLD - cart.total_price;
    const progress = Math.min((cart.total_price / FREE_SHIPPING_THRESHOLD) * 100, 100);
    document.getElementById('cd-shipping-progress').style.width = progress + '%';
    const shippingText = document.getElementById('cd-shipping-text');
    if (remaining <= 0) {
      shippingText.innerHTML = '🎉 Du erhältst <strong>kostenlosen Versand!</strong>';
    } else {
      const euros = (remaining / 100).toFixed(2).replace('.', ',');
      shippingText.innerHTML = `Noch <strong>${euros} €</strong> bis zum kostenlosen Versand`;
    }

    // Items
    const itemsEl = document.getElementById('cd-items');
    if (cart.items.length === 0) {
      itemsEl.innerHTML = '<p style="font-size:13px;color:#888;text-align:center;padding:40px 0">Dein Warenkorb ist leer.</p>';
    } else {
      itemsEl.innerHTML = cart.items.map(item => {
        const price = (item.final_line_price / 100).toFixed(2).replace('.', ',');
        const originalPrice = (item.original_line_price / 100).toFixed(2).replace('.', ',');
        const hasDiscount = item.final_line_price < item.original_line_price;
        const discountPct = hasDiscount ? Math.round((1 - item.final_line_price / item.original_line_price) * 100) : 0;

        return `
          <div class="cd__item" data-key="${item.key}">
            <img class="cd__item-img" src="${item.image}" alt="${item.product_title}">
            <div class="cd__item-body">
              <span class="cd__item-name">${item.product_title}</span>
              ${item.variant_title ? `<span class="cd__item-variant">${item.variant_title}</span>` : ''}
              <div class="cd__item-qty">
                <button onclick="CartDrawer.updateQty('${item.key}', ${item.quantity - 1})">−</button>
                <span>${item.quantity}</span>
                <button onclick="CartDrawer.updateQty('${item.key}', ${item.quantity + 1})">+</button>
              </div>
            </div>
            <div>
              <div class="cd__item-price">${price} €</div>
              ${hasDiscount ? `<span class="cd__item-badge">– ${discountPct}%</span>` : ''}
            </div>
          </div>
        `;
      }).join('');
    }

    // Summary
    const subtotal = (cart.total_price / 100).toFixed(2).replace('.', ',');
    document.getElementById('cd-subtotal').textContent = subtotal + ' €';
    document.getElementById('cd-checkout-total').textContent = subtotal + ' €';
    document.getElementById('cd-shipping-label').textContent = cart.total_price >= FREE_SHIPPING_THRESHOLD ? 'Gratis' : 'Wird berechnet';

    // Savings
    const originalTotal = cart.items.reduce((s, i) => s + i.original_line_price, 0);
    const saving = originalTotal - cart.total_price;
    if (saving > 0) {
      document.getElementById('cd-saving-row').style.display = 'flex';
      document.getElementById('cd-saving').textContent = '-' + (saving / 100).toFixed(2).replace('.', ',') + ' €';
    } else {
      document.getElementById('cd-saving-row').style.display = 'none';
    }
  },

  async updateQty(key, qty) {
    if (qty < 0) return;
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
    this.fetchAndRender();
  },

  async applyDiscount() {
    const code = document.getElementById('cd-discount-input')?.value?.trim();
    if (!code) return;
    // Shopify hat keine direkte Cart-Discount API – redirect zur Checkout URL mit Discount
    window.location.href = `/discount/${code}?redirect=/checkout`;
  }
};

document.addEventListener('DOMContentLoaded', () => CartDrawer.init());